import { usePartnerTierIconMap } from '../../utils/getPartnerTierContent';
import { EXCLUDED_COUNTRIES } from '../constants/excludedCountries';
import { useFilterConfig } from '../hooks/useFilterConfig';
import { CountryFilter } from './reusableFilters/CountryFilter';
import { LanguageFilter } from './reusableFilters/LanguageFilter';
import { PaginatedSelectFilter } from './reusableFilters/PaginatedSelectFilter';
import { SelectFilter } from './reusableFilters/SelectFilter';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SolutionsPartnerFilterControls() {
  const {
    PROFILE_ACCREDITATIONS,
    PROFILE_CATALOG_SERVICES,
    PROFILE_INDUSTRIES,
    PROFILE_SUPPORTED_LISTINGS,
    PROFILE_BUDGET,
    PROFILE_CERTIFICATIONS,
    PROFILE_LANGUAGES,
    PROFILE_LOCATION_COUNTRY,
    PROFILE_OFFICE_LOCATION,
    PROFILE_SOLUTIONS_PARTNER_TIER
  } = useFilterConfig();
  const tierIconMap = usePartnerTierIconMap();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_CATALOG_SERVICES,
      menuWidth: 350,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_INDUSTRIES,
      menuWidth: 300,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_ACCREDITATIONS,
      multi: true
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_OFFICE_LOCATION
    }), /*#__PURE__*/_jsx(CountryFilter, {
      filter: PROFILE_LOCATION_COUNTRY,
      excludedCountries: EXCLUDED_COUNTRIES
    }), /*#__PURE__*/_jsx(LanguageFilter, {
      filter: PROFILE_LANGUAGES
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_BUDGET,
      multi: true
    }), /*#__PURE__*/_jsx(PaginatedSelectFilter, {
      filter: PROFILE_SUPPORTED_LISTINGS
    }), /*#__PURE__*/_jsx(PaginatedSelectFilter, {
      filter: PROFILE_CERTIFICATIONS,
      menuWidth: 400
    }), /*#__PURE__*/_jsx(SelectFilter, {
      filter: PROFILE_SOLUTIONS_PARTNER_TIER,
      iconMap: tierIconMap,
      multi: true
    })]
  });
}